<template>
  <div class="page" :style="{height:fixedHeight+'px'}">
   <div class="screenLine">
     <el-input  @keyup.enter.native="handelComClick" v-model="keyword" placeholder="搜索商品" style="width: 240px; margin-right: 16px"></el-input>
     <el-cascader v-model="categoryId" :options="classOptions" :props="{ label: 'label', value: 'id',multiple: false,emitPath:true }"
						@change="handelComClick" ref="chooseRegionDom"></el-cascader>
			<el-select v-model="status" placeholder="上架状态" class="titleSelect" @change="handleComClick">
				<el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
			</el-select>
     <el-button type="warning" plain @click="handleResetClick">重置</el-button>
    </div>
    <div class="tableBox">
     <el-table :data="tableData" style="width: 100%" height="100%">
       <el-table-column label="线上分类" width="200">
        <template slot-scope="scope">
						{{ scope.row.onlineCategoryInfo == null ? '--' : scope.row.onlineCategoryInfo.name }}
					</template>
       </el-table-column>
       <el-table-column  label="排序" width="200">
         <template slot-scope="scope">
          {{ scope.row.selectNewSort}}
        </template>
       </el-table-column>
       <el-table-column  prop="onlineName" label="线上名称">
        
       </el-table-column>
       <el-table-column  label="品牌">
          <template slot-scope="scope">
           {{ scope.row.brand}}
         </template>
       </el-table-column>
       <el-table-column label="状态">
        <template slot-scope="scope">
						<div v-if="scope.row.appShelves == 0">未上架</div>
						<div v-if="scope.row.appShelves == 1">已上架</div>
						<div v-if="scope.row.appShelves == -1">已下架</div>
					</template>
       </el-table-column>
       <el-table-column label="操作" width="200">
         <template slot-scope="scope">
           <el-button v-if="$buttonAuthority('mall-edit')" type="text" size="small" @click="edit(scope.row)">编辑排序</el-button>
           <el-button type="text" size="small" @click="handelStartEndClick(scope.row, -1)"
						v-if="scope.row.appShelves == 1&&$buttonAuthority('mall-down')">下架</el-button>
						<el-button type="text" size="small" @click="handelStartEndClick(scope.row, 1)"
						v-if="scope.row.appShelves == -1||scope.row.appShelves == 0" v-show="$buttonAuthority('mall-up')">上架</el-button>
         </template>
       </el-table-column>
     </el-table>
     <page :page="page.page" :total="page.total" @change="changePage" style="margin: 10px 0;"></page>	
   </div>
   <el-dialog title="排序" :modal-append-to-body="false" :visible.sync="dialogconfirm_state" width="20%"
      >
      <!-- :before-close="handleClose" -->
      <el-form>
        <el-form-item label="排序">
          <el-input type="input" v-model.number="sort"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogconfirm_state = false">取 消</el-button>
        <el-button type="warning" @click="confirmSort">确 定</el-button>
      </span>
    </el-dialog>
   </div>
</template>

<script>
import page from "../../../components/page.vue"
export default {
 components: {
     page
   },
    data(){
       return{
         page: {
         page: 1,
         pageSize: 10,
         total: 0
       },
       shopId: this.$store.state.shopId,
       productId:'',
       categoryId: '',  //线上分类
       keyword: "", //关键字
       tableData:[], //商品列表
       status: 99,  //上架状态  -1:下架 0:未上架 1:上架 99:全部 默认为0
       sort:null,
       productType: 0, //产品类型  0:商品 1:药品
       dialogconfirm_state: false,
       classOptions: [], //线上分类列表
       statusOptions: [{
				value: 99,
				label: '全部'
			}, {
				value: 0,
				label: '未上架'
			}, {
				value: 1,
				label: '已上架'
			}, {
				value: -1,
				label: '已下架'
			}],
       fixedHeight: '',
       }
    },
    mounted(){
      this.getTableData()
      this.getClassData()
      this.fixedHeight = document.documentElement.clientHeight - 106;
    },
    methods:{
      // 编辑排序
      edit(row){
        this.productId=row.productId,
        this.sort=row.selectNewSort
        this.dialogconfirm_state = true
      },
      // 确定
     confirmSort(){
      let params = {
          shopId:this.$store.state.shopId,
          productId:this.productId,
          sort:this.sort
			}
			this.$http.post(process.env.VUE_APP_Url_baseData + '/api/shop/online/product/update/selectnew/sort', params).then((res)=>{
				if(res.code == 0){
          this.$message({
							message: '已修改',
							type: 'success'
						});
            this.dialogconfirm_state = false
        }
       this.getTableData()
      })
      },
      //上下架
      handelStartEndClick(row, status) {
      let params = {
        id: row.productId,
        status: status,
        shopId: this.shopId
      }
      let loading = this.$loading();
      this.$http.post(process.env.VUE_APP_Url_baseData + '/api/shop/online/product/update/AppShelves/status', params).then((res) => {
        if (res.code == 0) {
          loading.close()
          if (status == 1) {
            this.$message({
              message: '已上架',
              type: 'success'
            });
            this.getTableData()
          } else if (status == -1) {
            this.$message({
              message: '已下架',
              type: 'error'
            });
            this.getTableData()
          }
        }
      })
    },
      getTableData() {
      let params = {
        pageIndex: this.page.page,
        pageSize: this.page.pageSize,
        keyword: this.keyword,
        categoryId: this.categoryId,
        status: this.status,
        productType: this.productType,
        shopId:this.$store.state.shopId,
      }
      // let loading = this.$loading();
      this.$http.post(process.env.VUE_APP_Url_baseData + '/api/shop/online/product/selectnew/list', params).then((res) => {
        if (res.code == 0) {
          // loading.close();
          console.log('res',res);
          this.tableData = res.data.data;
          this.page.total = res.data.count;

        }
      })
    },
     // 搜索
     handelComClick(val) {
      console.log(val);
      this.categoryId = val[val.length - 1];
     this.page.page = 1;
     this.getTableData()
    },
       //重置
   handleResetClick() {
     this.page.page = 1;
     this.status = 99;
			this.keyword = '';
			this.categoryId = '';
     this.getTableData()
   },
   // 分页方法
     changePage(num) {
       this.page.page = num;
       this.getTableData();
     },
      //获取类别
      // getClassData() {
			// 	this.$http.get(process.env.VUE_APP_Url_baseData + '/api/online/product/goods/category/list').then((res) => {
			// 		if (res.code == 0) {
			// 			console.log(res.data, "获取类别");
			// 			this.classOptions = res.data
			// 		}
			// 	})
			// },
		getClassData() {
			this.$http.get(process.env.VUE_APP_Url_baseData + '/api/online/product/goods/category/list').then((res) => {
				if (res.code == 0) {
					this.classOptions = res.data
				}
			})
		},
    },
   
}
</script>

<style lang="scss" scoped>
.page {
 padding: 16px 16px 65px 16px;
 height: 100%;
 box-sizing: border-box;
 position: relative;
 .screenLine {
    display: flex;
    .titleSelect {
      width: 130px;
      margin-right: 16px;
    }
  }
 .tableBox {
    padding: 16px;
    border-radius: 8px;
    background-color: #fff;
    box-sizing: border-box;
    margin-top: 16px;
    height: calc(100% - 56px);
  }
}
</style>